import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "@/lib/api";
import { apiErrorPayload } from "@/lib/api-error";

/**
 * BUG-132 — scores a finished piece on demand, with the pipeline's own
 * evaluator (POST /pieces/:id/voice-score). Rendered only for roles that may
 * run it: a control a viewer cannot use is hidden, not disabled.
 */
export function ScoreVoiceButton({ pieceId }: { pieceId: number }) {
  const api = useApi();
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: () => api(`/pieces/${pieceId}/voice-score`, { method: "POST" }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["piece", pieceId] });
    },
  });

  return (
    <div className="voice-report-action">
      <button
        type="button"
        className="btn-primary"
        onClick={() => mutation.mutate()}
        disabled={mutation.isPending}
      >
        {mutation.isPending ? "Scoring…" : "Score voice"}
      </button>
      {mutation.isError && (
        <p className="voice-report-source" role="alert">
          {apiErrorPayload(mutation.error).message ?? "Scoring failed. Try again."}
        </p>
      )}
    </div>
  );
}
